import { getThemeValue } from '@tablekit/utils';
import { buttonThemeNamespace, buttonClassicTheme } from '../../themes.js';
var borderWidth = 2;

function resolveColor(targetValue, props) {
  var themeObject = getThemeValue("".concat(buttonThemeNamespace, ".").concat(props.color), buttonClassicTheme[props.color])(props);
  if (!themeObject) return '';
  var colorValue;

  if (themeObject[targetValue]) {
    colorValue = themeObject[targetValue];
  } else if (targetValue.indexOf('Transparent') > -1) {
    colorValue = themeObject[targetValue.replace('Transparent', '')];
  }

  var evalColorValue = colorValue || themeObject.main;
  if (!evalColorValue) return '';

  while (typeof evalColorValue === 'function') {
    evalColorValue = evalColorValue(props);
  }

  return evalColorValue;
}

export { borderWidth, resolveColor };
